// extracted by mini-css-extract-plugin
export default {"container":"CompaniesActions_container__6M9ZE"};